module.exports = __webpack_public_path__ + "cf49656302b3e37a8cc29699a1c370ef.fbx";